import React from 'react';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import PortalUsersVM from './PortalUsersVM';
import PortalUser from '../../Models/PortalUser/PortalUser';
import ContactAutoCompleteDropdown from "../Contacts/Components/ContactAutoCompleteDropdown";

interface IPortalUsersEditModalProps {
    viewModel: PortalUsersVM;
}

@observer
export default class PortalUsersEditModal extends React.Component<IPortalUsersEditModalProps> {

    constructor(props: IPortalUsersEditModalProps) {
        super(props);
    }

    public render() {
        const { viewModel } = this.props;

        return (
            <div>
                <Neo.Modal
                    title="Portal User"
                    bindModel={viewModel.meta.editingPortalUser}
                    acceptButton={viewModel.showSaveButton() && { text: "Save", icon: "save", onClick: () => viewModel.savePortalUser() }}>
                    {(item: PortalUser) => (
                        <div>
                            <Neo.FormGroupInline>
                                <ContactAutoCompleteDropdown bind={item.meta.contactId} bindDisplay={item.lookup.meta.contactName} parentName="User" onChanged={contact => {
                                    if (contact) {
                                        item.firstName = contact.firstName;
                                        item.lastName = contact.lastName;
                                        item.lookup.contactName = contact.fullName;
                                        item.lookup.emailAddress = contact.emailAddress;
                                    }
                                }} />
                            </Neo.FormGroupInline>
                            <Neo.FormGroupInline bind={item.meta.firstName} readOnly={item.contactId !== null} />
                            <Neo.FormGroupInline bind={item.meta.lastName} readOnly={item.contactId !== null} />
                            <Neo.FormGroupInline display={item.lookup.meta.emailAddress} placeholder="No Contact Selected" />
                            <Neo.FormGroupInline bind={item.meta.loginName} />
                            <Neo.FormGroupInline bind={item.meta.userGroupId} select={{ itemSource: viewModel.authorisationDataCache.userGroups, displayMember: "userGroupName" }} />
                            <Neo.FormGroupInline display={item.meta.isAdminPortal} label="Admin User?" footerText = "Indicates that this is an admin user, not a client user." />
                            <Neo.FormGroupInline bind={item.meta.isActive} />

                            {!item.isAdminPortal && 
                                <div className="mt-4">
                                    <h6>Linked Investors</h6>
                                    <NeoGrid.Grid items={item.investors} borderType="borderless" addButton={{ text: "Link Investor"}}>
                                        {(investor, meta) => (
                                            <NeoGrid.Row showInHeader={false}>
                                                <NeoGrid.Column>
                                                    <Neo.AutoCompleteDropDown
                                                        bind={investor.meta.investorId}
                                                        bindDisplay={investor.meta.investorName}
                                                        itemSource={viewModel.investorApiClient.getInvestorLookups} />
                                                </NeoGrid.Column>
                                                <NeoGrid.ButtonColumn showDelete />
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                </div>}
                        </div>
                    )}
                </Neo.Modal>
                
            </div>
        );
    }
}